import { Reveal, useInViewOnce } from "./Reveal";

const HAND_MASK = "/images/sophie-mask-hand.png";

export default function MeetSophie() {
  const [sectionRef, visible] = useInViewOnce(0.25);

  return (
    <section
      id="meet-sophie"
      ref={sectionRef}
      className={`meet-sophie relative scroll-mt-24 overflow-hidden py-20 md:py-28 lg:scroll-mt-28${visible ? " is-visible" : ""}`}
      data-testid="meet-sophie-section"
      data-visible={visible ? "true" : "false"}
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-90px] top-[30%] h-[190px] w-[190px] rounded-full bg-brand-aqua/50" />
        <div className="absolute right-[-70px] top-[14%] h-[150px] w-[150px] rounded-full bg-brand-peach/60" />
      </div>
      <div className="symp-container relative">
        <div className="mx-auto max-w-[760px] text-center">
          <div className="meet-sophie-stage" data-testid="meet-sophie-stage">
            <div className="sophie-behind-heading" data-testid="sophie-peek-mask">
              <img
                src="/images/sophie.png"
                alt="Sophie, the SympTrack heart character."
                width="1516"
                height="1328"
                className="sophie-peek"
                data-testid="meet-sophie-figure"
              />
            </div>
            <div className="meet-sophie__heading">
              <h2
                className="meet-sophie-title text-brand-teal"
                data-testid="meet-sophie-heading"
              >
                Meet Sophie
              </h2>
            </div>
            <img
              src="/images/sophie.png"
              alt=""
              aria-hidden="true"
              width="1516"
              height="1328"
              className="sophie-grip-hand sophie-peek"
              style={{
                WebkitMaskImage: `url(${HAND_MASK})`,
                maskImage: `url(${HAND_MASK})`,
              }}
              data-testid="meet-sophie-grip-hand"
            />
          </div>
          <Reveal delay={120}>
            <p className="mt-6 text-[19px] font-medium leading-[1.6] text-brand-ink md:text-[21px]">
              Sophie helps make the space between visits easier to notice,
              capture and understand.
            </p>
            <p className="mt-4 text-[18px] font-medium leading-[1.6] text-brand-ink md:text-[20px]">
              She helps patients organize what they are experiencing into
              clearer context their care team can review.
            </p>
            <p className="mt-6 text-[19px] font-extrabold text-brand-teal md:text-[21px]">
              Sophie supports the conversation. She does not replace it.
            </p>
          </Reveal>
        </div>
        <Reveal delay={80}>
          <div
            className="mx-auto mt-16 max-w-[840px] rounded-[36px] bg-brand-aqua/40 p-8 text-left md:p-12"
            data-testid="sophie-story"
          >
            <h3 className="text-[24px] font-extrabold text-brand-teal md:text-[28px]">
              Sophie&rsquo;s name has a story of its own.
            </h3>
            <p className="mt-4 text-[17px] font-medium leading-[1.65] text-brand-ink md:text-[19px]">
              She was named after my childhood dog, a tiny companion who stayed
              by my side through some of the hardest parts of growing up.
            </p>
            <p className="mt-4 text-[17px] font-medium leading-[1.65] text-brand-ink md:text-[19px]">
              I wanted Sophie to carry a little of that same feeling into
              SympTrack: something warm, familiar, and present while helping
              people make sense of what they are going through.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
